module.exports = __webpack_public_path__ + "img/D户型品鉴-右_image.eec5db2a.png";